import React, { useState } from "react";
import "../Assets/Styles/form.css";

const FormEn = () => {
  const [formData, setFormData] = useState({
    sl: "",
    ph: "",
    trackingCode: "",
    bannerImageUrl: "",
    tiles: [
      { title: "", imageUrl: "" },
      { title: "", imageUrl: "" },
      { title: "", imageUrl: "" },
      { title: "", imageUrl: "" },
    ],
  });

  const handleInputChange = (e, index) => {
    const { name, value } = e.target;

    if (name.startsWith("tile")) {
      const tiles = [...formData.tiles];
      const field = name.includes("Title") ? "title" : "imageUrl";
      tiles[index][field] = value;
      setFormData({ ...formData, tiles });
    } else {
      setFormData({ ...formData, [name]: value });
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
  
    // Generate HTML content
    const cvHtml = `
      <!DOCTYPE html>
      <html>
      <head>
      <link href="https://cdn.jsdelivr.net/npm/bootstrap@5.0.2/dist/css/bootstrap.min.css" rel="stylesheet" integrity="sha384-EVSTQN3/azprG1Anm3QDgpJLIm9Nao0Yz1ztcQTwFspd3yD65VohhpuuCOmLASjC" crossorigin="anonymous">
        <title>Generated Email</title>
      </head>
      <body>
        <div class="container">
        <h1>Email Preview</h1>
        <p>SL: ${formData.sl}</p>
        <p>PH: ${formData.ph}</p>
        <p>Tracking Code: ${formData.trackingCode}</p>
        <img src="${formData.bannerImageUrl}" alt="Banner" style="width:100%; height:auto;" />
        <div>
          ${formData.tiles
            .map(
              (tile) => `
            <div style="margin: 10px 0;">
              <img src="${tile.imageUrl}" alt="${tile.title}" style="width:200px; height:auto;" />
              <p>${tile.title}</p>
            </div>
          `
            )
            .join("")}
        </div>
        </div>
      </body>
      </html>
    `;
  
    try {
      if (window.showSaveFilePicker) {
        const handle = await window.showSaveFilePicker({
          suggestedName: "Generated_CV.html",
          types: [
            {
              description: "HTML Files",
              accept: { "text/html": [".html"] },
            },
          ],
        });

        const writable = await handle.createWritable();
        await writable.write(cvHtml);
        await writable.close();
        alert("File saved successfully!");
      } else {
        const blob = new Blob([cvHtml], { type: "text/html" });
        const link = document.createElement("a");
        link.href = URL.createObjectURL(blob);
        link.download = "Generated_CV.html";
        link.click();
        URL.revokeObjectURL(link.href);
        alert("File downloaded successfully!");
      }
    } catch (error) {
      console.error("Error saving file:", error);
    }
  };

  
  

  return (
    <div className="container my-5">
      <div className="form-container">
        <h1>Segmented Email</h1>
        <form onSubmit={handleSubmit}>
          <div className="row">
            <div className="col-md-6">
              <label>
                SL:
                <input
                  type="text"
                  name="sl"
                  value={formData.sl}
                  onChange={handleInputChange}
                />
              </label>
            </div>
            <div className="col-md-6">
              <label>
                PH:
                <input
                  type="text"
                  name="ph"
                  value={formData.ph}
                  onChange={handleInputChange}
                />
              </label>
            </div>
            <div className="col-md-6">
              <label>
                Tracking Code:
                <input
                  type="text"
                  name="trackingCode"
                  value={formData.trackingCode}
                  onChange={handleInputChange}
                />
              </label>
            </div>
            <div className="col-md-6">
              <label>
                Banner Image URL:
                <input
                  type="text"
                  name="bannerImageUrl"
                  value={formData.bannerImageUrl}
                  onChange={handleInputChange}
                />
              </label>
            </div>
          </div>

          <h4>Tiles</h4>
          {formData.tiles.map((tile, index) => (
            <div className="row" key={index}>
              <div className="col-md-6">
                <label>
                  Tile {index + 1} Image URL:
                  <input
                    type="text"
                    name={`tileImageUrl-${index}`}
                    value={tile.imageUrl}
                    onChange={(e) => handleInputChange(e, index)}
                  />
                </label>
              </div>
              <div className="col-md-6">
                <label>
                  Tile {index + 1} Title:
                  <input
                    type="text"
                    name={`tileTitle-${index}`}
                    value={tile.title}
                    onChange={(e) => handleInputChange(e, index)}
                  />
                </label>
              </div>
            </div>
          ))}

          <button type="submit">Generate Email</button>
        </form>
      </div>
    </div>
  );
};

export default FormEn;
